import { images } from "../../config/images";
import { siteContent } from "../../content/siteContent";
import { ResponsiveImage } from "./ResponsiveImage";

export function Personalized() {
  const { personalization } = siteContent;

  return (
    <section className="home-personalized home-section" aria-labelledby="home-personalized-title">
      <div className="home-shell">
        <p className="home-eyebrow">{personalization.eyebrow}</p>
        <h2 id="home-personalized-title" className="home-personalized__title">
          {personalization.titleLines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h2>

        <div className="home-personalized__layout">
          <figure className="home-personalized__figure">
            <ResponsiveImage
              image={images.personalization}
              className="home-personalized__image"
              sizes="(min-width: 960px) 44vw, 100vw"
            />
            <figcaption>{personalization.imageNote}</figcaption>
          </figure>

          <div className="home-personalized__content">
            <ul className="home-benefits" aria-label="Beneficios del proceso">
              {personalization.benefits.map((benefit, index) => (
                <li key={benefit.title}>
                  <span className="home-benefits__number" aria-hidden="true">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3>{benefit.title}</h3>
                    <p>{benefit.text}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="home-personalized__guides">
              <p>{personalization.guidesIntro}</p>
              <ul aria-label="Guías prácticas incluidas">
                {personalization.guides.map((guide) => (
                  <li key={guide}>{guide}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
